<template>
  <div>
    <api-header :id="id" tag="h3">
      {{ operation.summary }}
      <slot />
    </api-header>
    <api-note v-if="operation.note" :note="operation.note" data-cy="api-note" />
    <html-text tag="span" :html="operation.description" data-cy="api-description" />
    <api-method-badge :method="operation.method" :url="operation.server.url" data-cy="api-method-badge" />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { CallbackObject } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import HtmlText from '@/components/utils/HtmlText.vue';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import ApiNote from '@/components/api/content/common/ApiNote.vue';
import ApiMethodBadge from '@/components/api/content/common/ApiMethodBadge.vue';

defineProps({
  id: { type: String, required: true },
  operation: { type: Object as PropType<CallbackObject>, required: true },
});
</script>
